import React from 'react';
import { InputNumber, Text, InputSizes, TextAs, TextSizes } from '@clockout-dev/design-elements';
import ConfigurationCard from '../../../../common/configurationCard/ConfigurationCard';
import RulesPanel from '../../../../common/rulesPanel/RulesPanel';
import CapRulesTabs from './CapRulesTabs';
import VolumeAdvancedCapTenureRuleRow from './VolumeAdvancedCapTenureRuleRow';
import styles from '../styles/limitsForm.module.scss';

function VolumeAdvancedCapCard({
    value,
    enabled,
    onChange,
    onToggleEnabled,
    tenureRules = [],
    onAddTenureRule,
    onRemoveTenureRule,
    onUpdateTenureRule,
    capRuleTab,
    onChangeCapRuleTab,
    productTypes,
    geography
}) {
    return (
        <ConfigurationCard
            title="Volume Advanced Cap"
            description="The maximum $ volume a user can advance in a pay cycle"
            togglePosition="leading"
            enabled={enabled}
            onToggleEnabled={onToggleEnabled}
        >
            <div className={styles.cardInputRow}>
                <InputNumber
                    size={InputSizes.SMALL}
                    value={value}
                    prefix={<Text as={TextAs.SPAN} size={TextSizes.SMALL}>$</Text>}
                    onChange={onChange}
                    min={0}
                    max={999999.99}
                    step={0.01}
                    precision={2}
                    controls={false}
                    className={`${styles.inlineNumberInput} ${styles.amountField}`}
                />
                <Text as="span" size="s" className={styles.ruleLabel}>dollars per pay cycle</Text>
            </div>

            <div className={styles.tenureSection}>
                <Text as="span" size="s" className={styles.panelBlockTitle}>
                    Adjustments
                </Text>
                <CapRulesTabs
                    activeKey={capRuleTab}
                    onChange={onChangeCapRuleTab}
                    tenurePanel={(
                        <RulesPanel onAdd={onAddTenureRule} addLabel="Add tenure rule">
                            {tenureRules.map((rule) => (
                                <VolumeAdvancedCapTenureRuleRow
                                    key={rule.id}
                                    rule={rule}
                                    onUpdate={onUpdateTenureRule}
                                    onRemove={onRemoveTenureRule}
                                />
                            ))}
                        </RulesPanel>
                    )}
                    productTypes={productTypes}
                    geography={geography}
                    valueLabel="their volume cap will be exactly"
                    valueSuffixLabel={null}
                    inputProps={{ prefix: <Text as={TextAs.SPAN} size={TextSizes.SMALL}>$</Text>, min: 0, max: 999999.99, step: 0.01, precision: 2 }}
                    inputClassName={styles.amountField}
                />
            </div>
        </ConfigurationCard>
    );
}

export default VolumeAdvancedCapCard;
